<template>
  <NuxtLayout
    name="main-view"
    :hasBackButton="true"
    :headline="$t('dbc-label-contract-tariff')"
  >
    <div
      v-if="$route.query.error"
      class="grid grid-cols-card-layout gap-2xs max-tablet:flex max-tablet:flex-col"
    >
      <DbcBanner
        severity="warn"
        :has-border="true"
        :message="$t('dbc-text-bahn-bonus-error')"
        class="mb-xs"
        role="alert"
        aria-live="assertive"
      />
    </div>
    <div
      class="grid grid-cols-card-layout gap-xs max-tablet:flex max-tablet:flex-col"
    >
      <div v-if="tariffForChange" class="flex flex-col gap-y-2">
        <UtilsHeadline
          :level="3"
          class="text-primary"
          :text="$t('dbc-text-your-bahn-bonus-advantage')"
        />
        <Card :pt="specialCardPassThrough">
          <template #header>{{ tariffForChange.name }} </template>
          <template #content>
            <div
              v-if="tariffForChange.descriptionJson"
              class="c-tariff-card__content"
            >
              <ul :class="listStyle">
                <li
                  v-for="condition in tariffForChange.descriptionJson
                    .conditions"
                  class="relative pl-[24px]"
                >
                  <DbcSvg
                    class="text-light-green-500 inline-block absolute left-0"
                    name="dbc-tick"
                  ></DbcSvg>
                  {{ condition }}
                </li>
              </ul>
              <p
                v-if="tariffForChange.descriptionJson.notes"
                v-for="note in tariffForChange.descriptionJson.notes"
              >
                {{ note }}
              </p>
            </div>
            <NuxtLink
              :to="getPagePath['tariff-change'][locale]"
              :class="buttonPrimary"
            >
              {{ $t('dbc-btn-change-tariff') }}
            </NuxtLink>
          </template>
        </Card>
      </div>
      <div v-if="tariff" class="flex flex-col gap-y-2">
        <UtilsHeadline
          :level="3"
          class="text-cool-gray-500"
          :text="$t('dbc-text-your-active-tariff')"
        />
        <Card :pt="specialCardPassThrough">
          <template #header>{{ tariff.name }} </template>
          <template #content>
            <div v-if="tariff.descriptionObject" class="c-tariff-card__content">
              <ul :class="listStyle">
                <li
                  v-for="condition in tariff.descriptionObject.conditions"
                  class="relative pl-[24px]"
                >
                  <DbcSvg
                    class="text-light-green-500 inline-block absolute left-0"
                    name="dbc-tick"
                  ></DbcSvg>
                  {{ condition }}
                </li>
              </ul>
              <p
                v-if="tariff.descriptionObject.notes"
                v-for="note in tariff.descriptionObject.notes"
              >
                {{ note }}
              </p>
            </div>
            <DbcBanner
              severity="info"
              :message="$t('dbc-banner-tariff-info')"
            />
            <NuxtLink
              target="_blank"
              :to="getPagePath['priceList'][locale]"
              :class="`${buttonSecondary} flex justify-center items-center gap-x-1`"
            >
              {{ $t('dbc-text-pricelist') }}
              <DbcSvg name="dbc-navigation-link"></DbcSvg>
            </NuxtLink>
          </template>
        </Card>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useCustomerStore } from '../../../../stores/customer'

const customerStore = useCustomerStore()
const { tariff, tariffForChange } = storeToRefs(customerStore)

const { locale } = useI18n()
</script>
